import React from 'react';
import { ButtonTextLight } from '../../../styles/global.styles';
import { ContainerSmallButtonIcon } from './styles';

interface ICustomButtonWithIcon {
  width: number;
  icon?: string | React.ReactNode;
  title: string;
  action?: () => void;
}

const CustomButtonWithIcon = ({
  width,
  action,
  icon,
  title,
}: ICustomButtonWithIcon) => {
  return (
    <ContainerSmallButtonIcon width={width} onClick={action}>
      {icon && (typeof icon === 'string' ? <img src={icon} alt="" /> : icon)}
      <ButtonTextLight>{title}</ButtonTextLight>
    </ContainerSmallButtonIcon>
  );
};

export { CustomButtonWithIcon };
